import { useState, useRef, useEffect } from "react";
import { CSSTransition } from "react-transition-group";

////////// jess: Dev: Loading On
let devLoadingOn = true;

const Loading = ({appLoaded, setLoadingOn, pageCurrent, setPageChangeOn, setPageOn}) => {
  const [loadingShow, setLoadingShow] = useState(true);

  const partLoadingRef = useRef(null);
  const elPathRef = useRef(null);

  useEffect(() => {
    if(!devLoadingOn) setLoadingShow(false); // jess: Dev: call to hide loading

    if(appLoaded === false) return;

    if(!elPathRef.current) return;

    const elPath1Use = elPathRef.current;

    const onAnimationIteration = (e) => {
      document.querySelectorAll('.loading .logo-mask').forEach((el) => {
        el.style.animationPlayState = "paused";
        el.style.animation = "none";
      });
      setLoadingShow(false);

      console.log(`Loading: onAnimationIteration : loadingShow: false`);
    }

    elPath1Use.addEventListener('animationiteration', onAnimationIteration);

    return () => {
      (appLoaded && elPath1Use) && elPath1Use.removeEventListener('animationiteration', onAnimationIteration)
    };
  }, [appLoaded, setLoadingOn]);

  const onLoadingExit = () => {
    setPageChangeOn((prev) => ({...prev, [pageCurrent]: true}));
    console.log(`Loading: onLoadingExit : setPageChangeOn: ${pageCurrent}: true`);
  }

  const onLoadingExited = ()=> {
    document.querySelectorAll('.loading .container').forEach((el) => { el.style.animationPlayState = "paused"; });
    setLoadingOn(false);
    console.log(`Loading: onLoadingExited : setLoadingOn(false)`);
  }

  return (
    <CSSTransition
      nodeRef={partLoadingRef}
      in={loadingShow}
      timeout={{ exit: 1000 }}
      classNames="loading"
      onExit={onLoadingExit}
      onExited={onLoadingExited}
    >
      <div className='part loading' ref={partLoadingRef}>
        <section className="sector sector-h-full" style={{"--sector-ar-max": 2.23}}>
          <div className="container container-w-full container-w-no-gutter-out">
            <div className="container-in">

              <div className="contents-wrapper">

                <div className="components">
                  <img className="components-svg-ar" src="data:image/svg+xml;utf8,&lt;svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'&gt;&lt;/svg&gt;" alt="components placement svg" />
  
                  <div className="logo">
                    <svg className="svg-logo" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1000 1000" >
                      <mask id="loading-logo-mask-g">
                        <use className="logo-mask logo-mask2" xlinkHref="#b3-u-2-mask" ref={elPathRef} />
                        <use className="logo-mask logo-mask1" xlinkHref="#b3-u-1-mask" />
                      </mask>
                      <use className="logo-path logo-path1 front" xlinkHref="#b3-u-1-path" mask="url(#loading-logo-mask-g)" />
                      <use className="logo-path logo-path2 front" xlinkHref="#b3-u-2-path" mask="url(#loading-logo-mask-g)" />
                    </svg>
                  </div>
                  
                </div>

              </div>

            </div>
          </div>
        </section>
      </div>
    </CSSTransition>
  );
}

export default Loading;